<template>
  <header class="qbar">
    <div class="qbar__inner">
      <div class="qbar__accent" aria-hidden="true"></div>
      <div class="qbar__logo">
        <v-img :src="logoSrc" width="150" height="auto" contain></v-img>
      </div>
      <div class="qbar__accent qbar__accent--right" aria-hidden="true"></div>
    </div>
  </header>
</template>

<script>
import logoSideBar from "../../../public/assets/img/quatro_black_logo.svg";
import { mapActions } from "pinia";
import { useI18nStore } from "../../stores/i18nStore";

export default {
  props: ["menuItems", "title", "user"],
  data() {
    return {
      rail: false,
      logoSrc: logoSideBar,
    };
  },
  methods: {
    ...mapActions(useI18nStore, ["setLocale"]),
    navigate(route) {
      this.$router.replace(route);
    },
    changeLanguage() {
      this.setLocale(this.$i18n.locale);
      this.$router.go();
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;700&display=swap");

.qbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  width: 100%;
  background: #ffffff;
  border-bottom: 1px solid #f1f5f9;
  box-shadow: 0 1px 16px rgba(30, 58, 138, 0.06);
  font-family: "Plus Jakarta Sans", sans-serif;
  padding-top: env(safe-area-inset-top, 0px);
}

.qbar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 10vh;
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Logo */
.qbar__logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

/* Dekoratif çizgi aksanı */
.qbar__accent {
  flex: 1;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, #f97316 0%, #fed7aa 60%, transparent 100%);
  opacity: 0.55;
}
.qbar__accent--right {
  background: linear-gradient(
    270deg,
    #f97316 0%,
    #fed7aa 60%,
    transparent 100%
  );
}
</style>
